module.exports = __webpack_public_path__ + "img/login_sideimg.a8f82583.jpg";